import { useFeatureFlag } from './use-feature-flag';
import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useLocation } from 'react-router-dom';
import { isOrderDetailsPath } from '../../orders/order-details/routing';

export const useEnableMultiPackageShipmentsOrderDetails = () => {
  const isFeatureEnabled = useFeatureFlag(FeatureFlagDeclarations.enableMultiPackageShipmentsOrderDetails);
  const location = useLocation();
  const isOrderDetails = isOrderDetailsPath(location.pathname);

  return isFeatureEnabled && isOrderDetails;
};
